// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__1nUlj","title":"BackImages_title__1lCLd","images":"BackImages_images__1OjHJ"};